import React, { useState } from "react";
// ui
import Chip from "@mui/material/Chip";
// style
import { createStyles, makeStyles, styled } from "@material-ui/styles";
import PropTypes from "prop-types";
import classNames from "classnames";
// config

// useStyle
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const basicChipProps = {
  padding: "4px 12px",
};

const StyledChipContained = styled(Chip)(({ theme }) => ({
  ...basicChipProps,
  "&.MuiChip-root": {
    backgroundColor: "#3bbff0",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#06a2e6",
      color: "#fff",
    },
  },
  "&.MuiChip-contained": {},
}));

const StyledChipGradient = styled(Chip)(({ theme }) => ({
  ...basicChipProps,
  "&.MuiChip-root": {
    backgroundImage: "linear-gradient(to bottom, #3bbff0, #06a2e6)",
    color: "#fff",
    "&:hover": {
      backgroundImage: "linear-gradient(to bottom, #06a2e6, #06a2e6)",
    },
  },
}));

const StyledChipNeutral = styled(Chip)(({ theme }) => ({
  ...basicChipProps,
  "&.MuiChip-root": {
    backgroundColor: "#e6e9ef",
    color: "#121212",
    "&:hover": {
      backgroundColor: "#c9c9c9",
    },
  },
}));

const StyledChipOutlined = styled(Chip)(({ theme }) => ({
  ...basicChipProps,
  "&.MuiChip-root": {
    border: "solid 1px #e6e9ef",
    backgroundColor: "#fff",
    color: "#121212",
    "&:hover": {
      backgroundColor: "#e6e9ef",
    },
  },
}));

const StyledChipText = styled(Chip)(({ theme }) => ({
  ...basicChipProps,
  "&.MuiChip-root": {
    backgroundColor: "#fff",
    color: "#121212",
    "&:hover": {
      backgroundColor: "#f7f8fa",
    },
  },
}));

const StyledChipDisabled = styled(Chip)(({ theme }) => ({
  ...basicChipProps,
  "&.MuiChip-root": {
    backgroundColor: "#e6e9ef",
    color: "#c9c9c9",
  },
}));

const StyledChipDisabledDark = styled(Chip)(({ theme }) => ({
  ...basicChipProps,
  "&.MuiChip-root": {
    backgroundColor: "#505050",
    color: "#909090",
  },
}));

//
const ChipMain = ({ variant, label, className, ...restProps }) => {
  // style
  const classes = useStyles();
  // props

  // local state

  const getProps = () => ({
    ...restProps,
    label: label || "",
    className: classNames(className),
  });

  const getCustomChip = () => {
    let CustomChip;
    const customProps = getProps();
    switch (variant) {
      case "contained":
        CustomChip = StyledChipContained;
        break;
      case "gradient":
        CustomChip = StyledChipGradient;
        break;
      case "neutral":
        CustomChip = StyledChipNeutral;
        break;
      case "outlined":
        CustomChip = StyledChipOutlined;
        break;
      case "text":
        CustomChip = StyledChipText;
        break;
      case "disabled":
        CustomChip = StyledChipDisabled;
        break;
      default:
        CustomChip = StyledChipContained;
    }
    return <CustomChip {...customProps} />;
  };

  return getCustomChip();
};

ChipMain.propTypes = {
  variant: PropTypes.oneOf([
    "contained",
    "gradient",
    "neutral",
    "outlined",
    "text",
    "disabled",
  ]),
  label: PropTypes.node,
  className: PropTypes.string,
};

ChipMain.defaultProps = {
  variant: "contained",
  label: "label",
  className: "",
};

export default ChipMain;
